import { ColDef, GridOptions, ICellRendererParams } from "ag-grid-community";
import ProgramRenderer from "~/pages/Compliance/CompliancePositionsTable/ProgramRenderer";
import { LinkedPositionsInfo } from "../../../types";

export const defaultColDef: ColDef = {
  sortable: false,
  filter: false,
  resizable: true,
  minWidth: 167,
  cellStyle: { display: "flex", alignItems: "center", textOverflow: "ellipsis" },
};

export const gridOptions: GridOptions = {
  rowHeight: 42,
  headerHeight: 42,
  suppressCellFocus: true,
  suppressRowHoverHighlight: true,
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  domLayout: "autoHeight",
};

export const columnDefinition: ColDef<LinkedPositionsInfo>[] = [
  {
    headerName: "Positions name",
    field: "investingAccountName",
    valueGetter: (params) => {
      const data = params.data;
      if (!data) return "";
      return `${data.investingAccountName || ""} in ${data.entityName || ""}`;
    },
    flex: 1.5,
  },
  {
    headerName: "Role",
    field: "role",
    flex: 1,
  },
  {
    headerName: "Manager",
    field: "arenaName",
    flex: 1,
  },
  {
    headerName: "Program",
    field: "program",
    cellRenderer: ProgramRenderer,
    cellRendererParams: (params: ICellRendererParams<LinkedPositionsInfo>) => ({
      value: [params.data?.program],
    }),
    flex: 1,
  },
];
